import { type GetExamEventExamineeByIdQuery } from '@exam-center/graphql';

type ExamEventExamineeData =
  GetExamEventExamineeByIdQuery['ecGetExamEventExamineeById']['examEventExaminee'];

export function mapExamEventExamineeData(examEventExamineeData: ExamEventExamineeData | undefined) {
  const { title, firstName, middleName, lastName } = examEventExamineeData?.examinee ?? {};

  const email = examEventExamineeData?.email ?? '';

  return {
    fullName: [title, firstName, middleName, lastName].filter(Boolean).join(' '),
    email,
  };
}
